import { AddSecurityPermissions, GetAllSecurityPermissionsByRoleId, GetRoleListByClientIdAndClientSecret } from "../ApiEndPoints";
import { axiosGet, axiosGetDetails, axiosPost } from "../AxiosRequests";


export default class SecurityPermissionServices {

    async getRoleListByClientIdAndClientSecret(request) {
        return axiosGetDetails(GetRoleListByClientIdAndClientSecret, request);
    }
    async getAllSecurityPermissionsByRoleId(request) {
        
        return axiosGet(GetAllSecurityPermissionsByRoleId, request);
    }
   async addSecurityPermissions(request) {
    
    return axiosPost(AddSecurityPermissions, request);
}
}